import "@fontsource-variable/manrope";
import "@fontsource-variable/newsreader";
import "./styles.css";

import { initializeSite } from "./interactions.js";

initializeSite();
document.documentElement.classList.add("js");
